import styled from 'styled-components'

export const Container = styled.div`
  background: ${props => props.theme.blankColor};
  height: 100%;
`